import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postTeacherReserveMentor() {
    const { apiPostTeacherReserveMentor } = apiConfig.getStaticUrls();

    return postFetch(apiPostTeacherReserveMentor);
}
